import { Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { GuardClass, GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { AUTH_CONSTS } from '../store/auth/auth.consts';
import { CONFIG_CONSTS } from '../store/config/config.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';
import { USER_CONSTS } from '../store/user/user.consts';

export class LogoutGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    await store.dispatch(`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.actions.logout}`);
    await store.dispatch(`${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.actions.clearModule}`);
    await store.dispatch(`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.actions.clearModule}`);
    if (store.getters.hasOwnProperty(`${USER_CONSTS.moduleName}/${USER_CONSTS.getters.user}`)) {
      await store.dispatch(`${USER_CONSTS.moduleName}/${USER_CONSTS.actions.clearModule}`);
    }
    next({
      ...to,
      name: ROUTER_CONSTS.routes.login,
      replace: true
    });
  }

}
